import React from 'react';
import { PuffLoader } from 'react-spinners';

const Spinner = () => {
  return (
    <div
      style={{
        display: 'inline-block',
        marginTop: '10rem',
        marginLeft: '26rem',
      }}
    >
      <PuffLoader color="#859491" />
    </div>
  );
};

export default Spinner;
